import { render, staticRenderFns } from "./MRadio.vue?vue&type=template&id=4713f627&"
import script from "./MRadio.vue?vue&type=script&lang=js&"
export * from "./MRadio.vue?vue&type=script&lang=js&"
import style0 from "./MRadio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports